import { PageMetaData } from '../../components/providers/pageMetaData/pageMetaData';
import { Contact as ContactBlock } from '../../components/blocks/contact/Contact';
import styles from './Contact.module.scss';

export const Contact = ({ pages, uiBlocks }) => {
  const upPage = !!pages ? pages.find((el) => el.id === 386) : false;
  const upContact = !!uiBlocks ? uiBlocks.find((el) => el.id === 104) : false;
  const seo = !!upPage ? upPage.acf.seo : false;

  return (
    <>
      {!!seo && <PageMetaData seo={seo} />}
      <div className="main padding-header">{!!upContact ? <ContactBlock upContact={upContact} /> : ''}</div>
    </>
  );
};
